import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { BASE_URL_API } from '../../References/url'
import AuthContext from '../../Store/auth-context'
import styles from './AllCampaigns.module.css'

const AllCampaigns = () => {
    const authCtx = useContext(AuthContext)
    const [allCampaigns, setAllCampaigns] = useState([])
    const [loading, setLoading] = useState(true)

    const getAllCampaigns = async () => {
        try {
            const response = await fetch(BASE_URL_API + "/getAllCampaigns", {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    clientIdentifier: authCtx.clientIdentifier
                })
            })

            if (!response.ok) {
                console.error("Something went wrong : Server Error")
            } else {
                const respo = await response.json()
                if (respo.status === "success") {
                    setAllCampaigns(respo.response)
                } else {
                    if (respo.message === "token Expired, please login again!") {
                        authCtx.logout()
                    }
                }
                console.log(respo)
            }
        } catch (err) {
            console.error("Fetch error:", err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAllCampaigns()
    }, [])

    const formatDate = (dateString) => {
        if (!dateString || dateString.startsWith('0000')) return "-"
        const options = { year: 'numeric', month: 'short', day: 'numeric' }
        return new Date(dateString).toLocaleDateString(undefined, options)
    }

    return (
        <div className={styles.allCampaignsContainer}>
            <div className={styles.pageTitle}>All Campaigns</div>
            {loading ? (
                <p className={styles.loadingText}>Loading campaigns...</p>
            ) : allCampaigns.length === 0 ? (
                <p className={styles.noDataText}>No Campaigns Found</p>
            ) : (
                <div className={styles.tableWrapper}>
                    <table className={styles.campaignsTable}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Campaign Identifier</th>
                                <th>Title</th>
                                <th>Brand</th>
                                <th>Created On</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {allCampaigns.map((campaign, index) => (
                                <tr key={campaign.ID}>
                                    <td>{index + 1}</td>
                                    <td className={styles.campaignIdentifier}>
                                        <Link to={`/campaign/${campaign.pdsCampaignIdentifier}`}>
                                            {campaign.pdsCampaignIdentifier}
                                        </Link>
                                    </td>
                                    <td>{campaign.pdsTitle}</td>
                                    <td>{campaign.brandName}</td>
                                    <td>{formatDate(campaign.createdOn)}</td>
                                    <td>{campaign.hasDeleted === "0" ? "Active" : "Deleted"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    )
}

export default AllCampaigns
